import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { msg } from 'api';
import CookieDisclaimerComponent from '../components/CookieDisclaimer';

import { setUserHidDisclaimer, setCookieConsent } from '../actions/cookieDisclaimer';
import COOKIE from '../cookieConsent';

class CookieDisclaimer extends PureComponent {
  static propTypes = {
    userHidDisclaimer: PropTypes.bool,
    cookieDisclaimerBetaFeature: PropTypes.bool,
    oneTrustCookiesBetaFeature: PropTypes.bool,
    cookieConsent: PropTypes.bool.isRequired,
    setUserHidDisclaimer: PropTypes.func.isRequired,
  };

  componentDidMount() {
    if (!this.props.cookieConsent) {
      setCookieConsent();
    }
  }

  render() {
    const { userHidDisclaimer, cookieConsent, cookieDisclaimerBetaFeature, oneTrustCookiesBetaFeature } = this.props;
    const show = (cookieDisclaimerBetaFeature && !userHidDisclaimer && !cookieConsent && !oneTrustCookiesBetaFeature);

    if (!show) {
      return null;
    }

    const text = msg.common.weUseCookies.msg;
    const link = {
      label: msg.common.weUseCookies.linkLabel,
      href: msg.common.weUseCookies.linkHref,
    };

    return (
      <CookieDisclaimerComponent
        text={text}
        link={link}
        closeHandler={this.props.setUserHidDisclaimer}
      />
    );
  }
}

export default connect(state => ({
  userHidDisclaimer: state.cookieDisclaimer.userHidDisclaimer,
  cookieConsent: state.userPreferences[COOKIE.name] === 'y',
  cookieDisclaimerBetaFeature: state.user.betaFeatures.includes('COOKIES_DISCLAIMER'),
  oneTrustCookiesBetaFeature: state.user.betaFeatures.includes('ONE_TRUST_COOKIES'),
}), {
  setUserHidDisclaimer,
})(CookieDisclaimer);
